import { Alert, Box, Grid, Snackbar, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import logoHorizontal from "../../../../Assets/images/logoMenu.png";
import styles from "../../Rastreabilidade.module.css";

/** Capa do portal, espelhando a FirstPage do campo. */
function PrimeiraPagina({ nomeDistribuidora }) {
	const [codigoDigitado, setCodigoDigitado] = useState("");
	const [aberto, setAberto] = useState(false);

	function rastrear() {
		if (codigoDigitado.trim() !== "") {
			window.location = `/rastreabilidade?id=${encodeURIComponent(
				codigoDigitado.trim(),
			)}`;
		} else {
			setAberto(true);
		}
	}

	return (
		<div>
			<Box component="main" sx={{ width: "100%", height: "80vh", m: 0 }}>
				<Grid
					container
					sx={{
						display: "flex",
						justifyContent: "space-between",
						height: "100%",
					}}
				>
					<Grid size={12} sx={{ display: "flex", justifyContent: "flex-start" }}>
						<img src={logoHorizontal} className={styles.img} alt="Sisagri" />
					</Grid>

					<Grid
						size={12}
						sx={{ display: "flex", justifyContent: "center", alignItems: "start" }}
					>
						<Box
							sx={{
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								alignItems: "flex-start",
							}}
						>
							<Typography variant="h4" sx={{ fontWeight: "600" }}>
								Rastreie aqui o seu produto!
							</Typography>
							<Typography variant="h6" sx={{ fontWeight: "300" }}>
								Digite o código de rastreio que se encontra na embalagem do produto
							</Typography>
							<Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
								<input
									type="text"
									value={codigoDigitado}
									onChange={(e) => setCodigoDigitado(e.target.value)}
									className={styles.inputFistPage}
								/>
								<button className={styles.buttonFistPage} onClick={rastrear}>
									Rastrear
								</button>
							</Box>
						</Box>
					</Grid>

					<Grid
						size={12}
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "end",
							alignItems: "start",
						}}
					>
						<h1>Olá, eu sou a {nomeDistribuidora ?? "sua distribuidora"}.</h1>
						<h2>Aqui vou te apresentar a origem do seu produto, vamos lá?</h2>
					</Grid>
				</Grid>
			</Box>

			<Stack spacing={2} sx={{ width: "100%" }}>
				<Snackbar
					open={aberto}
					autoHideDuration={5000}
					onClose={() => setAberto(false)}
				>
					<Alert
						onClose={() => setAberto(false)}
						severity="error"
						sx={{ width: "100%" }}
					>
						Campo vazio ou inválido...
					</Alert>
				</Snackbar>
			</Stack>
		</div>
	);
}

export default PrimeiraPagina;
